export const formatPrice = (price) => {
    return price % 1 === 0 ? `$${price.toFixed(0)}` : `$${price.toFixed(2)}`;
}
export const formatPhoneNumber = (phoneNumber) => {
    if (typeof phoneNumber !== 'string') {
        phoneNumber = String(phoneNumber);
    }
    phoneNumber = phoneNumber.replace(/\D/g,'');
    phoneNumber = phoneNumber.length > 10 ? phoneNumber.substring(phoneNumber.length - 10) : phoneNumber;

    return `+1 (${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
}
